'use strict';

// These will self-invoke if required
import 'url-polyfill';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import 'promise-polyfill/src/polyfill';
import 'formdata-polyfill';
import "dialog-closedby-polyfill";

// Slide Up, Slide Down
import 'dom-slider';

// Vue widgets
import './components';

import donationPanel from './modules/donation-panel';
import globalNavigation from 'modules/global-navigation';
import scroller from './modules/scroller';
import accordion from './modules/accordion';
import stickyHeader from './modules/sticky-header';
import globalHeader from './modules/global-header';
import eventHeader from './modules/event-header';
import eventHeaderSticky from './modules/event-header-sticky';
import eventNavigation from './modules/event-navigation';
import dialog from './modules/dialog';
import artistList from './modules/artist-list';
import imageGallery from './modules/image-gallery';
import pullQuote from './modules/pull-quote';
import toggle from './modules/toggle';
import eventHistory from './modules/event-history';
import headerVideo from './modules/header-video';
import videoModal from './modules/video-modal';
import imageModal from './modules/image-modal';
import homeHero from './modules/home-hero';
import videoPreview from './modules/video-preview';
import youtubeThumbnail from './modules/youtube-thumbnail';
import spotifyThumbnail from './modules/spotify-thumbnail';
import pieceNotes from './modules/piece-notes';
import packageDetails from './modules/package-details';
import tabbing from './modules/tabbing';
import userStatus from './modules/user-status';
import globalTopBar from './modules/global-top-bar';
import weglot from './modules/weglot';
import orchestraRoster from './modules/orchestra-roster';
import announcer from './modules/announcer';
import formValidate from './modules/form-validate';
import favoritesCount from './modules/favorites-count';
import messages from './modules/messages';
import eventGrid from './modules/event-grid';
import cartStatus from './modules/cart-status';
import accountMenu from './modules/account-menu';
import workAudio from './modules/work-audio';
import membershipLevels from './modules/membership-levels';

// To make sure the code is run AFTER VueJS is loaded
// Code in imported modules is run asynchronously so cannot control the order but will ALWAYS run before the file doing the import
function load () {
    stickyHeader();
    globalNavigation();
    donationPanel();
    scroller();
    accordion();
    eventHeader();
    eventHeaderSticky();
    eventNavigation();
    dialog();
    artistList();
    imageGallery();
    pullQuote();
    toggle();
    eventHistory();
    headerVideo();
    videoModal();
    imageModal();
    homeHero();
    videoPreview();
    youtubeThumbnail();
    spotifyThumbnail();
    pieceNotes();
    packageDetails();
    tabbing();
    userStatus();
    globalTopBar();
    weglot();
    orchestraRoster();
    announcer();
    formValidate();
    messages();
    globalHeader(); // issue with this file, so moving to end
    favoritesCount();
    eventGrid();
    cartStatus();
    accountMenu();
    workAudio();
    membershipLevels();
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
    load();
} else {
    document.addEventListener('DOMContentLoaded', load);
}
